/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liability_Analysis_Field_Guilt_DegreeInputs */

const en_liability_analysis_field_guilt_degree = /** @type {(inputs: Liability_Analysis_Field_Guilt_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Possible fault attribution`)
};

const pt_br2_liability_analysis_field_guilt_degree = /** @type {(inputs: Liability_Analysis_Field_Guilt_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Possível atribuição de culpa`)
};

/**
* | output |
* | --- |
* | "Possible fault attribution" |
*
* @param {Liability_Analysis_Field_Guilt_DegreeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const liability_analysis_field_guilt_degree = /** @type {((inputs?: Liability_Analysis_Field_Guilt_DegreeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liability_Analysis_Field_Guilt_DegreeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liability_analysis_field_guilt_degree(inputs)
	return pt_br2_liability_analysis_field_guilt_degree(inputs)
});